<app-page-container>

  <header class="header">
    <h1 class="header__title">Inventário</h1>
    <div class="filter">
      <h2 class="filter__title">Filtrar</h2>
      <form class="filter__search-form">
        <div class="div__filter-search">
          <input class="filter__search-input" type="text" placeholder="Pesquisar...">
          <input class="filter__submit-button" type="submit" value="Buscar">
          <app-filtro-generico [filterInputs]="[
        { label: 'N de Serie', formControlName: 'NumSerie' },
        { label: 'CodSite', formControlName: 'CodSite' }
      ]" (OnClickApplyButton)="getInventario(true)" (filterData)="receiveFilterData($event)"
            class="filters__component"></app-filtro-generico>
        </div>
      </form>
      <h3 class="filter__subtitle" *ngIf="this.inventarios.registros.length > 0">Mostrar por:</h3>
      <form class="filter__select-form" *ngIf="this.inventarios.registros.length > 0">
        <div class="div__filters">
          <label class="filter__label">
            <input class="filter__select-input" type="checkbox" checked
              (change)="handleActiveFilter('numeroDeSerie', $event)">
            N. de Série
          </label>
          <label class="filter__label">
            <input class="filter__select-input" type="checkbox" checked
              (change)="handleActiveFilter('patrimonio', $event)">
            Patrimônio
          </label>
          <label class="filter__label">
            <input class="filter__select-input" type="checkbox" checked (change)="handleActiveFilter('modelo', $event)">
            Modelo
          </label>
          <label class="filter__label">
            <input class="filter__select-input" type="checkbox" checked (change)="handleActiveFilter('site', $event)">
            Site/Filial
          </label>
          <label class="filter__label">
            <input class="filter__select-input" type="checkbox" checked
              (change)="handleActiveFilter('departamento', $event)">
            Departamento
          </label>
          <label class="filter__label">
            <input class="filter__select-input" type="checkbox" checked
              (change)="handleActiveFilter('emPosseDe', $event)">
            Em posse de
          </label>
          <label class="filter__label">
            <input class="filter__select-input" type="checkbox" checked
              (change)="handleActiveFilter('pessoaParaContato', $event)">
            Pessoa para contato
          </label>
        </div>
      </form>
    </div>
    <div *ngIf="autorizacoes.realizarDownloadListagemInventario">
      <app-botoes-files *ngIf="this.inventarios.registros.length > 0"
        (OnClickApplyPDFButton)="getDownloadPDFInventario()"
        (OnClickApplyCSVButton)="getDownloadCSVInventario()"></app-botoes-files>
    </div>
  </header>
  <app-tabela *ngIf="this.inventarios.registros?.length; else retornoOSNA;
    "
    [cabecalhos]="['N de Série', 'Patrimônio', 'Modelo', 'Site/Filial', 'Departamento', 'Em posse de', 'Pessoa para contato']"
    [items]="inventarios.registros"
    [colunasOcultas]="['N de Série', 'Patrimônio', 'Modelo', 'Site/Filial', 'Departamento', 'Em posse de', 'Pessoa para contato']"
    [condicoesColunas]="[{ columnName: 'N de Série', condition: autorizacoes.exibirDetalhesInventario && activeFilter.numeroDeSerie },
                          { columnName: 'Patrimônio', condition: activeFilter.patrimonio },
                          { columnName: 'Modelo', condition: activeFilter.modelo },
                          { columnName: 'Site/Filial', condition: activeFilter.site },
                          { columnName: 'Departamento', condition: activeFilter.departamento },
                          { columnName: 'Em posse de', condition: activeFilter.emPosseDe },
                          { columnName: 'Pessoa para contato', condition: activeFilter.pessoaParaContato }]">
    <tr class="section__tbody__tr" *ngFor="let inventario of inventarios.registros">
      <td class="section__tbody__tr__td" *ngIf="activeFilter.numeroDeSerie && autorizacoes.exibirDetalhesInventario"><a
          class="section__tbody__navigation-link"
          [routerLink]="autorizacoes.exibirDetalhesInventario ? ['detalhes', inventario?.numserie] : null"
          routerLinkActive="active">
          {{inventario?.numserie}}</a>
      </td>
      <td class="section__tbody__tr__td" *ngIf="activeFilter.patrimonio">{{inventario.numPat}}</td>
      <td class="section__tbody__tr__td" *ngIf="activeFilter.modelo">{{inventario?.modelo}}</td>
      <td class="section__tbody__tr__td" *ngIf="activeFilter.site">{{inventario?.endSite}}</td>
      <td class="section__tbody__tr__td" *ngIf="activeFilter.departamento">inventario?.departamento</td>
      <td class="section__tbody__tr__td" *ngIf="activeFilter.emPosseDe">inventario?.emPosseDe</td>
      <td class="section__tbody__tr__td" *ngIf="activeFilter.pessoaParaContato">{{inventario.contato}}
      </td>
    </tr>
  </app-tabela>
  <app-paginacao nomeDaLista="itens" [(dados)]="inventarios" (dadosChange)="getInventario()"
    *ngIf="this.inventarios.registros.length !== 0"></app-paginacao>
</app-page-container>
<ng-template #retornoOSNA>Não há registros.</ng-template>
<app-modal-general #modalSucesso [titulo]="'Download'" [botao]="'Fechar'" [mensagem]="'Download realizado com sucesso!'"
  (cliqueBotao)="fecharModal()"></app-modal-general>
